import KunLoading5 from './src/index'

KunLoading5.install = function (Vue){
	Vue.component(KunLoading5.name, KunLoading5);
}

export default KunLoading5;
